/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { TranscodedFilesRequest } from '../models/TranscodedFilesRequest';
import { HttpFile } from '../http/http';

export class TranscoderDataRequest {
    'files': TranscodedFilesRequest;
    'thumbnails': Array<string>;
    'spriteSheets': Array<string>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "files",
            "baseName": "files",
            "type": "TranscodedFilesRequest",
            "format": ""
        },
        {
            "name": "thumbnails",
            "baseName": "thumbnails",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "spriteSheets",
            "baseName": "spriteSheets",
            "type": "Array<string>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return TranscoderDataRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

